module.exports = function(app) {
    app.filter('decimalsPersentage', function() {
      return function(input, decimals) {
        // Ensure input is a number
        if (isNaN(input)) return 'N/A';
        // Default to 2 decimal places if not provided
        decimals = decimals || 2;
        // Convert input to fixed decimal places
        var factor = Math.pow(10, decimals); // 10^decimals
        return (Math.floor(input * factor*100) / factor).toFixed(decimals);
      };
    })
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/filter/decimalsPercentageFilter.js
// module id = 456
// module chunks = 0